export default {
  namespaced: true,
  state: {
    oldSearchField: {
      contact: {
        page: 0,
        args: {},
      },
      personneMorale: {
        page: 0,
        args: {},
      },
      instance: {
        page: 0,
        args: {},
      },
    },
  },
  mutations: {
    updateSearchField(state, payload) {
      state.oldSearchField[payload.entity].page = 1;
      state.oldSearchField[payload.entity].args[payload.field] = payload.value;
    },
  },
};
